module.exports = "/legacy/dbca02ccae435224b1e38b455c3b0a97.png";